import { cn } from "design-system/utils"
import { ensure, formatNumber, formatPercent } from "lopermut"
import { usePredefinedSegmentTranslations } from "modules/segments/hooks/usePredefinedSegmentTranslations"
import { RFM_LAYOUT } from "modules/segments/lib/rfmLayout"
import { useTranslation } from "react-i18next"
import { SegmentGroupResponseDataSchema } from "schema"
import z from "zod"

type Props = {
  segmentGroup: z.infer<typeof SegmentGroupResponseDataSchema>
}

export function RfmMiniGrid({ segmentGroup }: Props) {
  const { t } = useTranslation()
  const { getSegmentTranslation } = usePredefinedSegmentTranslations()

  const gridSegments = segmentGroup.segments.filter((segment) => segment.name in RFM_LAYOUT)

  return (
    <div className="grid grid-cols-5 grid-rows-5 gap-1 h-55">
      {gridSegments.map((segment) => {
        const layout = ensure(RFM_LAYOUT[segment.name])

        return (
          <div
            key={segment.id}
            className={cn(
              "flex flex-col justify-center rounded-[5px] px-1.5 py-1 overflow-hidden",
              layout.className,
            )}
            style={{ gridColumn: layout.column, gridRow: layout.row }}
          >
            <span className="text-[10px] leading-tight truncate">
              {getSegmentTranslation(segment.name, segmentGroup)}
            </span>
            <span className="flex flex-row items-baseline gap-x-1 leading-tight whitespace-nowrap">
              <span className="text-xs font-medium font-mono">
                {formatNumber({ amount: segment.count, fix: 0 })}
              </span>
              <span className="text-[10px]">
                {t("segments.distribution.percentage", {
                  percentage: formatPercent({
                    amount: (segment.count / (segmentGroup.customersCount || 1)) * 100,
                    fix: 1,
                  }),
                })}
              </span>
            </span>
          </div>
        )
      })}
    </div>
  )
}
